module.exports = __webpack_public_path__ + "assets/img/18d23809bbb6b953e1541f1a966b857c.png";